module.exports = __webpack_public_path__ + "img/modal-delete-auto.35ed5fca.svg";